import React, { useEffect, useState } from 'react';
import Dialog from '../common/Dialog';
import { listClassRosters } from '../../api/classRosterApi';
import './RosterStudentPicker.css';

/** 1학기 명단을 2학기로 복사하면 같은 반이 두 개라, 반 이름마다 뒤 학기 명단 하나만 보여 준다. */
export const latestSemesterRosters = (rosters = []) => {
  const byLabel = new Map();
  rosters.forEach((roster) => {
    const key = roster.label || roster.id;
    const kept = byLabel.get(key);
    if (!kept || Number(roster.semester || 0) > Number(kept.semester || 0)) byLabel.set(key, roster);
  });
  const keep = new Set(byLabel.values());
  return rosters.filter((roster) => keep.has(roster));
};

/** 이번 학년도 명단. 명단이 없으면 빈 배열이라 명단 관련 화면을 아예 그리지 않는다. */
export const useClassRosters = (userId) => {
  const [rosters, setRosters] = useState([]);
  useEffect(() => {
    if (!userId) {
      setRosters([]);
      return undefined;
    }
    let alive = true;
    listClassRosters()
      .then((items) => { if (alive) setRosters(latestSemesterRosters(items.filter((item) => item.student_count > 0))); })
      .catch(() => { if (alive) setRosters([]); });
    return () => { alive = false; };
  }, [userId]);
  return rosters;
};

const RosterStudentPicker = ({ open, rosters = [], selected = null, title = '학생 고르기', note = '', onPick, onClear = null, onClose }) => {
  const [rosterId, setRosterId] = useState(selected?.rosterId || rosters[0]?.id || '');
  useEffect(() => {
    if (open) setRosterId(selected?.rosterId || rosters[0]?.id || '');
  }, [open, rosters, selected?.rosterId]);
  const roster = rosters.find((item) => item.id === rosterId) || rosters[0];

  return (
    <Dialog open={open} onClose={onClose} title={title} size="md">
      {note && <p className="roster-picker-note">{note}</p>}
      {rosters.length > 1 && (
        <div className="roster-picker-tabs" role="tablist" aria-label="반">
          {rosters.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={item.id === roster?.id}
              className={item.id === roster?.id ? 'is-active' : ''}
              onClick={() => setRosterId(item.id)}
            >
              {item.label || '우리 반'}
            </button>
          ))}
        </div>
      )}
      <ul className="roster-picker-grid" data-testid="roster-picker-students">
        {(roster?.students || []).map((student) => {
          const isSelected = selected?.rosterId === roster.id && selected?.sid === student.sid;
          return (
            <li key={student.sid}>
              <button
                type="button"
                className={isSelected ? 'is-selected' : ''}
                onClick={() => onPick?.({ roster, student })}
              >
                <span>{student.number}</span>
                {student.name}
              </button>
            </li>
          );
        })}
      </ul>
      {onClear && selected && (
        <button type="button" className="roster-picker-clear" onClick={onClear}>
          {selected.name} 기록에서 빼기
        </button>
      )}
    </Dialog>
  );
};

export default RosterStudentPicker;
